import { Component } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { WorkOperationalWorkComponent } from '../work-operational-work.component';

@Component({
    selector: 'app-work-operational-work-dialog',
    templateUrl: './work-operational-work-dialog.component.html',
    styleUrl: './work-operational-work-dialog.component.scss',
    imports: [
        WorkOperationalWorkComponent,
    ],
})
export class WorkOperationalWorkDialogComponent extends BaseDialogComponent {
}
